import DialogComponent from "components/Dialog";

export default class SelectDoctorDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            id: null,
        };
    }

    show(id, saveCb, key) {
        this.dialogTitle = key === "coordinatorId" ? "client.choiceCoordinator" : "client.choiceDoctor";
        this.key = key;
        this.state.id = id || null;
        this.saveCb = saveCb;

        super.show();
    }

    save() {
        this.hide();

        if (this.saveCb?.apply)
            this.saveCb(this.state.id || null);
    }

    renderContent() {
        return (
            <div className="content">
                {this.insertSelectDoctor({
                    value: this.state.id,
                    type: this.key === "coordinatorId" ? "coordinator" : null,
                    onClick: this.changeState.bind(this, "id")
                })}
            </div>
        );
    }
}
